export const messages = {
  fr: {
    app: {
      name: '3asass',
      identity: 'Identité',
      auth_sublabel: 'Auth · Identité'
    },
    common: {
      language: 'Langue',
      or: 'ou',
      redirecting: 'Redirection…'
    },
    auth: {
      dashboard: {
        welcome: 'Bonjour {name}',
        user: 'Utilisateur'
      },
      login: {
        subtitle: "Connectez-vous à votre compte 3asass.",
        title: 'Connexion',
        email: 'Adresse email',
        password: 'Mot de passe',
        submit: 'Se connecter',
        google_login: 'Continuer avec Google',
        googleError: 'Authentification Google échouée. Veuillez réessayer.',
        register_link: 'Pas de compte ? S\'inscrire'
      },
      register: {
        subtitle: "Un seul compte pour toutes les applications 3asass.",
        phone_hint: "Facultatif. Avec l’indicatif du pays, par exemple +212612345678.",
        rule_length: "Au moins 8 caractères",
        rule_match: "Les deux mots de passe sont identiques",
        login_instead: "Se connecter avec cet email",
        title: 'Inscription',
        name: 'Nom complet',
        email: 'Adresse email',
        password: 'Mot de passe',
        password_confirmation: 'Confirmer le mot de passe',
        phone: 'Numéro de téléphone',
        submit: "S'inscrire",
        google_register: 'S\'inscrire avec Google',
        login_link: 'Déjà un compte ? Se connecter',
        password_mismatch: 'Les mots de passe ne correspondent pas.'
      },
      totp: {
        title: 'Authentification à deux facteurs',
        code: 'Code TOTP',
        submit: 'Vérifier',
        help: 'Entrez le code à 6 chiffres généré par votre application d\'authentification.'
      },
      validation: {
        required: "Ce champ est obligatoire.",
        email: "Entrez une adresse email valide."
      },
      password: {
        show: "Afficher le mot de passe",
        hide: "Masquer le mot de passe"
      },
      logout: 'Déconnexion',
      errors: {
        email_taken: "Un compte existe déjà avec cet email.",
        password_short: "Le mot de passe doit contenir au moins 8 caractères.",
        invalid_credentials_hint: "Inscrit avec Google ? Utilisez « Continuer avec Google ».",
        offline: 'Serveur injoignable. Vérifiez votre connexion et réessayez.',
        invalid_credentials: 'Email ou mot de passe incorrect.',
        invalid_code: 'Code incorrect. Réessayez.',
        too_many: 'Trop de tentatives. Patientez un instant puis réessayez.',
        email: 'Cet email est invalide ou déjà utilisé.',
        password: 'Le mot de passe doit contenir au moins 8 caractères, dont une majuscule et une minuscule.',
        phone: 'Numéro de téléphone invalide.',
        name: 'Indiquez votre nom complet.',
        check: 'Vérifiez les informations saisies puis réessayez.',
        generic: 'Une erreur est survenue. Réessayez.',
      },
    },
    profile: {
      title: 'Mon Profil',
      account_settings: 'Paramètres du compte',
      subtitle: 'Gérez vos informations, votre photo et les options de connexion de votre compte 3asass.',
      personal_info: 'Informations personnelles',
      personal_info_desc: 'Ces informations sont utilisées dans toutes les applications connectées.',
      security_note_title: 'Sécurité du compte',
      security_note_desc: 'Gardez votre email à jour et utilisez un mot de passe fort si vous vous connectez sans Google.',
      password_desc: 'Mettez à jour le mot de passe utilisé pour la connexion par email.',
      google: 'Google',
      connected: 'Connecté',
      not_connected: 'Non connecté',
      back: 'Retour',
      name: 'Nom complet',
      email: 'Adresse email',
      phone: 'Numéro de téléphone',
      current_password: 'Mot de passe actuel',
      new_password: 'Nouveau mot de passe',
      confirm_password: 'Confirmer le mot de passe',
      change_password: 'Changer le mot de passe',
      set_password: 'Définir un mot de passe',
      save: 'Enregistrer',
      saved: 'Profil mis à jour avec succès',
      google_connected: 'Compte connecté via Google',
      link_google: 'Lier mon compte Google',
      link_error: 'Impossible de lier le compte Google',
      link_error_already_linked: 'Ce compte est déjà lié à un autre compte Google',
      link_error_google_account_in_use: 'Ce compte Google est déjà utilisé par un autre utilisateur',
    },
    dashboard: {
      home: 'Accueil',
      intro: 'Votre compte centralise l’accès aux applications 3asass et garde vos informations de connexion synchronisées.',
      account_ready: 'Compte prêt',
      identity_status: 'Identité vérifiée',
      provider: 'Connexion',
      status: 'Statut',
      active: 'Actif',
      password_account: 'Email',
      quick_actions: 'Accès rapide',
      choose_app: 'Choisir une application',
      profile_prompt_title: 'Complétez votre profil',
      profile_prompt_desc: 'Ajoutez un téléphone, une photo ou liez Google pour faciliter vos prochaines connexions.',
      cards: {
        logistics: { title: 'Logistics', desc: "Plateforme d'opérations logistiques" },
        landing: { title: 'Accueil', desc: 'Page d\'accueil et découverte' },
        placeholder: { title: 'Bientôt', desc: 'Nouvelle application à venir' },
        enter: 'Accéder'
      },
      coming_soon: {
        title: 'Tableau de bord à venir',
        desc: 'Les statistiques et informations de votre compte apparaîtront ici prochainement.'
      }
    }
  },
  en: {
    app: {
      name: '3asass',
      identity: 'Identity',
      auth_sublabel: 'Auth · Identity'
    },
    common: {
      language: 'Language',
      or: 'or',
      redirecting: 'Redirecting…'
    },
    auth: {
      dashboard: {
        welcome: 'Welcome {name}',
        user: 'User'
      },
      login: {
        subtitle: "Sign in to your 3asass account.",
        title: 'Sign In',
        email: 'Email address',
        password: 'Password',
        submit: 'Sign In',
        google_login: 'Continue with Google',
        googleError: 'Google authentication failed. Please try again.',
        register_link: 'Don\'t have an account? Sign Up'
      },
      register: {
        subtitle: "One account for all 3asass apps.",
        phone_hint: "Optional. With the country code, for example +212612345678.",
        rule_length: "At least 8 characters",
        rule_match: "Both passwords match",
        login_instead: "Sign in with this email",
        title: 'Sign Up',
        name: 'Full name',
        email: 'Email address',
        password: 'Password',
        password_confirmation: 'Confirm password',
        phone: 'Phone number',
        submit: 'Sign Up',
        google_register: 'Sign up with Google',
        login_link: 'Already have an account? Sign In',
        password_mismatch: 'Passwords do not match'
      },
      totp: {
        title: 'Two-Factor Authentication',
        code: 'TOTP Code',
        submit: 'Verify',
        help: 'Enter the 6-digit code generated by your authenticator app.'
      },
      validation: {
        required: "This field is required.",
        email: "Enter a valid email address."
      },
      password: {
        show: "Show password",
        hide: "Hide password"
      },
      logout: 'Logout',
      errors: {
        email_taken: "This email already has an account.",
        password_short: "The password needs at least 8 characters.",
        invalid_credentials_hint: "Signed up with Google? Use “Continue with Google”.",
        offline: "Can't reach the server. Check your connection and try again.",
        invalid_credentials: 'Email or password is incorrect.',
        invalid_code: 'Incorrect code. Try again.',
        too_many: 'Too many attempts. Wait a moment and try again.',
        email: 'That email is invalid or already in use.',
        password: 'The password needs at least 8 characters, with one uppercase and one lowercase letter.',
        phone: 'Invalid phone number.',
        name: 'Enter your full name.',
        check: 'Check what you entered and try again.',
        generic: 'Something went wrong. Try again.',
      },
    },
    profile: {
      title: 'My Profile',
      account_settings: 'Account settings',
      subtitle: 'Manage your account details, profile photo, and sign-in options across 3asass apps.',
      personal_info: 'Personal information',
      personal_info_desc: 'These details are shared with every connected 3asass application.',
      security_note_title: 'Account security',
      security_note_desc: 'Keep your email current and use a strong password if you sign in without Google.',
      password_desc: 'Update the password used for email sign-in.',
      google: 'Google',
      connected: 'Connected',
      not_connected: 'Not connected',
      back: 'Back',
      name: 'Full name',
      email: 'Email address',
      phone: 'Phone number',
      current_password: 'Current password',
      new_password: 'New password',
      confirm_password: 'Confirm password',
      change_password: 'Change password',
      set_password: 'Set a password',
      save: 'Save',
      saved: 'Profile updated successfully',
      google_connected: 'Account connected via Google',
      link_google: 'Link my Google account',
      link_error: 'Could not link Google account',
      link_error_already_linked: 'This account is already linked to another Google account',
      link_error_google_account_in_use: 'This Google account is already used by another user',
    },
    dashboard: {
      home: 'Home',
      intro: 'Your account is the central place for accessing 3asass apps and keeping sign-in details in sync.',
      account_ready: 'Account ready',
      identity_status: 'Identity verified',
      provider: 'Sign-in',
      status: 'Status',
      active: 'Active',
      password_account: 'Email',
      quick_actions: 'Quick actions',
      choose_app: 'Choose an application',
      profile_prompt_title: 'Complete your profile',
      profile_prompt_desc: 'Add a phone number, profile photo, or Google link to make future sign-ins easier.',
      cards: {
        logistics: { title: 'Logistics', desc: 'Logistics operations platform' },
        landing: { title: 'Landing', desc: 'Home page and discovery' },
        placeholder: { title: 'Coming Soon', desc: 'New application coming soon' },
        enter: 'Enter'
      },
      coming_soon: {
        title: 'Dashboard Coming Soon',
        desc: 'Your account statistics and information will appear here soon.'
      }
    }
  },
  ar: {
    app: {
      name: '3asass',
      identity: 'الهوية',
      auth_sublabel: 'الهوية · الدخول'
    },
    common: {
      language: 'اللغة',
      or: 'أو',
      redirecting: 'جارٍ إعادة التوجيه…'
    },
    auth: {
      dashboard: {
        welcome: 'مرحباً {name}',
        user: 'مستخدم'
      },
      login: {
        subtitle: "سجّل الدخول إلى حسابك في 3asass.",
        title: 'تسجيل الدخول',
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        submit: 'تسجيل الدخول',
        google_login: 'المتابعة عبر Google',
        googleError: 'فشل تسجيل الدخول عبر Google. حاول مرة أخرى.',
        register_link: 'ليس لديك حساب؟ إنشاء حساب'
      },
      register: {
        subtitle: "حساب واحد لجميع تطبيقات 3asass.",
        phone_hint: "اختياري. مع رمز الدولة، مثال: +212612345678.",
        rule_length: "8 أحرف على الأقل",
        rule_match: "كلمتا المرور متطابقتان",
        login_instead: "تسجيل الدخول بهذا البريد",
        title: 'إنشاء حساب',
        name: 'الاسم الكامل',
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        password_confirmation: 'تأكيد كلمة المرور',
        phone: 'رقم الهاتف',
        submit: 'إنشاء حساب',
        google_register: 'إنشاء حساب عبر Google',
        login_link: 'لديك حساب بالفعل؟ تسجيل الدخول',
        password_mismatch: 'كلمتا المرور غير متطابقتين'
      },
      totp: {
        title: 'المصادقة الثنائية',
        code: 'رمز TOTP',
        submit: 'تحقق',
        help: 'أدخل الرمز المكون من 6 أرقام من تطبيق المصادقة الخاص بك.'
      },
      validation: {
        required: "هذا الحقل مطلوب.",
        email: "أدخل عنوان بريد إلكتروني صحيحاً."
      },
      password: {
        show: "إظهار كلمة المرور",
        hide: "إخفاء كلمة المرور"
      },
      logout: 'تسجيل الخروج',
      errors: {
        email_taken: "يوجد حساب بهذا البريد الإلكتروني بالفعل.",
        password_short: "كلمة المرور يجب أن تكون 8 أحرف على الأقل.",
        invalid_credentials_hint: "سجّلت عبر Google؟ استخدم «المتابعة مع Google».",
        offline: 'تعذّر الوصول إلى الخادم. تحقق من الاتصال وأعد المحاولة.',
        invalid_credentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
        invalid_code: 'الرمز غير صحيح. أعد المحاولة.',
        too_many: 'محاولات كثيرة. انتظر قليلاً ثم أعد المحاولة.',
        email: 'هذا البريد غير صحيح أو مستعمل من قبل.',
        password: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل، فيها حرف كبير وحرف صغير.',
        phone: 'رقم الهاتف غير صحيح.',
        name: 'اكتب الاسم الكامل.',
        check: 'راجع المعلومات التي كتبتها وأعد المحاولة.',
        generic: 'حدث خطأ. أعد المحاولة.',
      },
    },
    profile: {
      title: 'ملفي الشخصي',
      account_settings: 'إعدادات الحساب',
      subtitle: 'إدارة بيانات الحساب والصورة وخيارات تسجيل الدخول في تطبيقات 3asass.',
      personal_info: 'المعلومات الشخصية',
      personal_info_desc: 'تستخدم هذه البيانات في كل تطبيقات 3asass المرتبطة.',
      security_note_title: 'أمان الحساب',
      security_note_desc: 'حافظ على بريدك محدثاً واستخدم كلمة مرور قوية إذا كنت تدخل بدون Google.',
      password_desc: 'حدّث كلمة المرور المستخدمة لتسجيل الدخول بالبريد الإلكتروني.',
      google: 'Google',
      connected: 'متصل',
      not_connected: 'غير متصل',
      back: 'رجوع',
      name: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      current_password: 'كلمة المرور الحالية',
      new_password: 'كلمة المرور الجديدة',
      confirm_password: 'تأكيد كلمة المرور',
      change_password: 'تغيير كلمة المرور',
      set_password: 'تعيين كلمة مرور',
      save: 'حفظ',
      saved: 'تم تحديث الملف الشخصي بنجاح',
      google_connected: 'الحساب متصل عبر Google',
      link_google: 'ربط حساب Google',
      link_error: 'تعذر ربط حساب Google',
      link_error_already_linked: 'هذا الحساب مرتبط بالفعل بحساب Google آخر',
      link_error_google_account_in_use: 'حساب Google هذا مستخدم بالفعل من قبل مستخدم آخر',
    },
    dashboard: {
      home: 'الرئيسية',
      intro: 'حسابك هو المكان المركزي للوصول إلى تطبيقات 3asass ومزامنة بيانات الدخول.',
      account_ready: 'الحساب جاهز',
      identity_status: 'الهوية مؤكدة',
      provider: 'طريقة الدخول',
      status: 'الحالة',
      active: 'نشط',
      password_account: 'البريد الإلكتروني',
      quick_actions: 'اختصارات',
      choose_app: 'اختر تطبيقاً',
      profile_prompt_title: 'أكمل ملفك الشخصي',
      profile_prompt_desc: 'أضف رقم الهاتف أو الصورة أو اربط Google لتسهيل الدخول لاحقاً.',
      cards: {
        logistics: { title: 'لوجستيك', desc: 'منصة عمليات اللوجستيك' },
        landing: { title: 'الرئيسية', desc: 'الصفحة الرئيسية' },
        placeholder: { title: 'قريباً', desc: 'تطبيق جديد قريباً' },
        enter: 'دخول'
      },
      coming_soon: {
        title: 'لوحة التحكم قريباً',
        desc: 'إحصائيات ومعلومات حسابك ستظهر هنا قريباً.'
      }
    }
  },
  ma: {
    app: {
      name: '3asass',
      identity: 'الهوية',
      auth_sublabel: 'الهوية · دخول'
    },
    common: {
      language: 'اللغة',
      or: 'ولا',
      redirecting: 'كنحولو…'
    },
    auth: {
      dashboard: {
        welcome: 'أهلاً {name}',
        user: 'مستخدم'
      },
      login: {
        subtitle: "دخل لحسابك ديال 3asass.",
        title: 'دخول',
        email: 'الإيميل',
        password: 'كلمة السر',
        submit: 'دخول',
        google_login: 'كمّل ب Google',
        googleError: 'تسجيل الدخول ب Google مشي ناجح. حاول مرة أخرى.',
        register_link: 'ما عندكش حساب؟ سجل'
      },
      register: {
        subtitle: "حساب واحد لكاع تطبيقات 3asass.",
        phone_hint: "اختياري. مع كود البلاد، بحال +212612345678.",
        rule_length: "8 حروف على الأقل",
        rule_match: "كلمتين السر متطابقين",
        login_instead: "دخل بهاد الإيميل",
        title: 'تسجيل',
        name: 'السمية الكاملة',
        email: 'الإيميل',
        password: 'كلمة السر',
        password_confirmation: 'تأكيد كلمة السر',
        phone: 'رقم التليفون',
        submit: 'تسجيل',
        google_register: 'سجل ب Google',
        login_link: 'عندك حساب؟ دخل',
        password_mismatch: 'كلمتين السر ما متطابقينش'
      },
      totp: {
        title: 'المصادقة بجوج',
        code: 'الكود TOTP',
        submit: 'تحقق',
        help: 'دير الكود ديال 6 أرقام من تطبيق المصادقة.'
      },
      validation: {
        required: "هاد الخانة ضرورية.",
        email: "دخل إيميل صحيح."
      },
      password: {
        show: "بيّن كلمة السر",
        hide: "خبّي كلمة السر"
      },
      logout: 'خرج',
      errors: {
        email_taken: "كاين حساب بهاد الإيميل.",
        password_short: "كلمة السر خاصها 8 حروف على الأقل.",
        invalid_credentials_hint: "سجلتي بـ Google؟ استعمل «كمل بـ Google».",
        offline: 'ما قدرناش نوصلو للسيرفر. تأكد من الكونيكسيون وعاود.',
        invalid_credentials: 'الإيميل ولا كلمة السر ماشي صحيحين.',
        invalid_code: 'الكود ماشي صحيح. عاود جرب.',
        too_many: 'بزاف من المحاولات. تسنى شوية وعاود.',
        email: 'هاد الإيميل ماشي صحيح ولا مستعمل من قبل.',
        password: 'كلمة السر خاصها 8 حروف على الأقل، فيها حرف كبير وحرف صغير.',
        phone: 'رقم التليفون ماشي صحيح.',
        name: 'كتب السمية الكاملة ديالك.',
        check: 'شوف المعلومات اللي كتبتي وعاود.',
        generic: 'وقعت مشكلة. عاود المحاولة.',
      },
    },
    profile: {
      title: 'الپروفيل ديالي',
      account_settings: 'إعدادات الحساب',
      subtitle: 'سير المعلومات ديالك، الصورة، وطرق الدخول فكل تطبيقات 3asass.',
      personal_info: 'المعلومات الشخصية',
      personal_info_desc: 'هاد المعلومات كتستعمل فالتطبيقات المربوطة ب 3asass.',
      security_note_title: 'أمان الحساب',
      security_note_desc: 'خلي الإيميل ديالك صحيح واستعمل كلمة سر قوية إلا كنت كتدخل بلا Google.',
      password_desc: 'بدل كلمة السر اللي كتستعملها للدخول بالإيميل.',
      google: 'Google',
      connected: 'مربوط',
      not_connected: 'ما مربوطش',
      back: 'رجوع',
      name: 'السمية الكاملة',
      email: 'الإيميل',
      phone: 'رقم التليفون',
      current_password: 'كلمة السر الحالية',
      new_password: 'كلمة سر جديدة',
      confirm_password: 'تأكيد كلمة السر',
      change_password: 'بدّل كلمة السر',
      set_password: 'حدد كلمة سر',
      save: 'حفظ',
      saved: 'الپروفيل تجدد بنجاح',
      google_connected: 'الحساب مربوط ب Google',
      link_google: 'ربط حساب Google',
      link_error: 'ما قدرناش نربطو الحساب ب Google',
      link_error_already_linked: 'هاد الحساب مربوط من قبل ب Google آخر',
      link_error_google_account_in_use: 'هاد الحساب ديال Google مخدّم من قبل من عند واحد آخر',
    },
    dashboard: {
      home: 'الرئيسية',
      intro: 'الحساب ديالك هو البلاصة الرئيسية باش تدخل لتطبيقات 3asass وتبقى معلومات الدخول منظمة.',
      account_ready: 'الحساب واجد',
      identity_status: 'الهوية مؤكدة',
      provider: 'طريقة الدخول',
      status: 'الحالة',
      active: 'خدام',
      password_account: 'الإيميل',
      quick_actions: 'دخول سريع',
      choose_app: 'اختار تطبيق',
      profile_prompt_title: 'كمل الپروفيل ديالك',
      profile_prompt_desc: 'زيد رقم الهاتف، الصورة، ولا ربط Google باش الدخول يولي ساهل.',
      cards: {
        logistics: { title: 'لوجستيك', desc: 'منصة ديال اللوجستيك' },
        landing: { title: 'الرئيسية', desc: 'الصفحة الرئيسية' },
        placeholder: { title: 'قريباً', desc: 'تطبيق جديد جاي' },
        enter: 'دخل'
      },
      coming_soon: {
        title: 'لوحة التحكم جاية',
        desc: 'إحصائيات ومعلومات حسابك غادي تظهر هنا قريباً.'
      }
    }
  }
}
